export default "<ng-template #settingsTemplate>\n\n</ng-template>\n<ng-template #contentTemplate>\n\n</ng-template>\n";